import { render, staticRenderFns } from "./PayAdjustments.vue?vue&type=template&id=96b35d0a"
import script from "./PayAdjustments.vue?vue&type=script&lang=js"
export * from "./PayAdjustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports